import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$pramsUrl = {
  createURL(param, key, encode) {
    if (param == null) return "";
    var paramStr = "";
    var t = typeof param;
    if (t == "string" || t == "number" || t == "boolean") {
      paramStr +=
        "&" +
        key +
        "=" +
        (encode == null || encode ? encodeURIComponent(param) : param);
    } else {
      for (var i in param) {
        var k =
          key == null
            ? i
            : key + (param instanceof Array ? "[" + i + "]" : "." + i);
        paramStr += this.createURL(param[i], k, encode);
      }
    }
    return paramStr;
  },
  getUrl(param, url) {
    return axios.defaults.baseURL + url + '?' + this.createURL(param).slice(1)
  },
  getUnix(date) {
    if (!date) return new Date().getTime()
    const dateArr = date.split('-')
    return new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0).getTime()
  }
}
Vue.prototype.upgradeHttp = function(url){
  if(typeof url === 'string') {
    if(url) {
      return url.replace('http://app.ncvt.net','')
    }
  }
  return url
}

Vue.filter('filterDate', (value, fmt) => {
  if (!value) return '-'

  const date = new Date(value)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
    'd+': date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
    'h+': date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
    'm+': date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
    's+': date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : str);
    }
  }
  return fmt
})

Vue.filter('getWeek', (value) => {
  if (!value) return '-'
  const date = new Date(value)
  const num = date.getDay()
  let week = '星期'
  switch (num) {
    case 0:
      week += '日'
      break;
    case 1:
      week += '一'
      break;
    case 2:
      week += '二'
      break;
    case 3:
      week += '三'
      break;
    case 4:
      week += '四'
      break;
    case 5:
      week += '五'
      break;
    case 6:
      week += '六'
      break;
    default:
      break;
  }
  return week
})

Vue.filter('costTime', (value) => {
  if (!value) return '-'
  const time = Math.floor(value / 1000)
  const day = Math.floor(time / (3600 * 24))
  const hour = Math.floor((time - day * 3600 * 24) / 3600)
  const minute = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60)
  const second = Math.floor(time - day * 3600 * 24 - hour * 3600 - minute * 60)
  let str = ''
  if (day > 0) {
    str += day + '天'
  }
  if (hour > 0) {
    str += hour + '时'
  }
  if (minute > 0) {
    str += minute + '分'
  }
  str += second + '秒'
  return str
})